// extracted by mini-css-extract-plugin
export default {"loadingSVG":"loading_loadingSVG__1i4MT","spinner":"loading_spinner__QseNd"};